import React, { useCallback, useState } from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
} from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import Route from "@assets/svg/DeliveryRoutes/route";
import EditRoute from "@assets/svg/DeliveryRoutes/EditRoute";
import { getRouteList } from "@services/api";
import { useFocusEffect } from "@react-navigation/native";
import t from "@constants/localization";
import { useDispatch } from "react-redux";
import { actions as configActions } from "@reducers/configReducer";
import NoRouteView from "./NoRouteView";

const DeliveryRouteList = ({ navigation, route }) => {
  useFocusEffect(
    useCallback(() => {
      fetchData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  );

  const [listData, setListData] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const PATH = "screens/CpDeliveryRoutes/DeliveryRoute";
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const { data } = await getRouteList();
      if (data?.routes?.length > 0) {
        dispatch(configActions.updateStarCpActiveRoute(true));
      }
      setListData(data?.routes || []);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onPressAddDeliveryRoute = () => {
    navigation.navigate("AddDeliveryRoute");
  };
  const onPressEditDeliveryRoute = (item) => {
    navigation.navigate("AddDeliveryRoute", { routeData: item, isEdit: true });
  };

  const renderRouteList = (item, index) => (
    <View key={index} style={styles.deliveryBoyItem}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          justifyContent: "space-between",
          marginBottom: 8,
        }}
      >
        <Text variant="body_text_1">{item.route_name || ""}</Text>

        <TouchableOpacity
          testID="cpdb-edit-btn"
          onPress={() => onPressEditDeliveryRoute(item)}
        >
          <EditRoute />
        </TouchableOpacity>
      </View>
      {!item.db_name ? null : (
        <View
          style={{
            flexWrap: "wrap",
            borderRadius: 24,
            backgroundColor: color.lightGrey,
            padding: 4,
            paddingHorizontal: 12,
            overflow: "hidden",
          }}
        >
          <Text
            numberOfLines={1}
            variant="body_text_3"
            style={{ color: color.mediumBlack }}
          >
            {item.db_name}
          </Text>
        </View>
      )}
    </View>
  );

  return (
    <View style={styles.maincontainer}>
      <HeaderWithBackAndTitle
        headertitle={t(`${PATH}/manageDeliveryRoute`)}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
      />

      {isloading ? (
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <ActivityIndicator size="large" color={color.primary} />
        </View>
      ) : listData?.length === 0 ? (
        <NoRouteView onPressAddDeliveryRoute={onPressAddDeliveryRoute} />
      ) : (
        <ScrollView
          keyboardShouldPersistTaps="handled"
          showsVerticalScrollIndicator={false}
        >
          <View style={styles.container}>
            <View style={styles.header}>
              <View
                style={{
                  backgroundColor: "rgba(237, 28, 36, 0.1)",
                  padding: 10,
                  borderRadius: 50,
                  right: 5,
                }}
              >
                <Route />
              </View>
              <Text variant="body_text_4" style={styles.headerText}>
                {t(`${PATH}/yourDeliveryRoute`)}
              </Text>
            </View>
            {listData?.map((item, index) => renderRouteList(item, index))}

            <TouchableOpacity
              testID="cpdb-add-btn"
              onPress={onPressAddDeliveryRoute}
              style={styles.addButton}
            >
              <Text variant="subtitle_16" style={styles.addButtonText}>
                {t(`${PATH}/addNewRoute`)}
              </Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  maincontainer: {
    flex: 1,
  },
  container: {
    backgroundColor: color.white,
    margin: 16,
    borderRadius: 10,
    borderColor: color.extraLightBlack,
    borderWidth: 0.5,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    paddingBottom: 10,
    justifyContent: "flex-start",
  },
  headerText: {
    marginLeft: 4,
  },
  addButton: {
    margin: 16,
    width: "45%",
    borderColor: color.plain_red,
    borderWidth: 1,
    borderRadius: 8,
    alignItems: "center",
  },

  addButtonText: {
    color: color.plain_red,
    padding: 8,
  },
  deliveryBoyItem: {
    alignItems: "flex-start",
    padding: 12,
    borderWidth: 1,
    borderColor: color.lightGrey,
    marginTop: 8,
    borderRadius: 10,
    marginHorizontal: 16,
  },
});

export default DeliveryRouteList;
